<div class="settings-container">
  <div class="settings-header">
    <div>
      <h1>Camera Settings</h1>
      <p class="subtitle">Preview each connected camera and adjust zoom or focus when the camera supports it.</p>
    </div>
    <button class="btn" type="button" (click)="refreshCameras()" [disabled]="isLoading">
      {{ isLoading ? 'Looking for cameras...' : 'Refresh cameras' }}
    </button>
  </div>

  <p class="status" *ngIf="isLoading && cameras.length === 0">Looking for cameras...</p>
  <p class="status error" *ngIf="!isLoading && errorMessage">{{ errorMessage }}</p>

  <div class="camera-grid" *ngIf="cameras.length > 0">
    <app-camera-card
      *ngFor="let camera of cameras; trackBy: trackByDeviceId"
      [deviceId]="camera.value"
      [label]="camera.label">
    </app-camera-card>
  </div>
</div>
